import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SpinnerService } from './core/services/loading.service';
import { SpinnerComponent } from './shared/components/spinner/spinner.component';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SessionKeepaliveService } from './core/services/session-keepalive.service';
import { ScrollNavComponent } from './shared/components/scroll-nav/scroll-nav.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SpinnerComponent, ToastModule, ConfirmDialogModule, ScrollNavComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  constructor(
    public spinner: SpinnerService,
    private sessionKeepalive: SessionKeepaliveService,
  ) {}

  ngOnInit(): void {
    this.sessionKeepalive.startPassiveWatcher();
  }
}
